'use client'

import { createContext, useContext, ReactNode } from 'react'

/**
 * Context to track if we're inside an i18n provider context
 * This is used by components that need to know if i18n is available
 * without crashing when it's not.
 */
interface I18nContextValue {
  isI18nAvailable: boolean
}

const I18nContext = createContext<I18nContextValue>({ isI18nAvailable: false })

/**
 * Provider component that marks its children as being in an i18n context
 * Should be placed inside NextIntlClientProvider
 */
export function I18nContextProvider({ children }: { children: ReactNode }) {
  return (
    <I18nContext.Provider value={{ isI18nAvailable: true }}>
      {children}
    </I18nContext.Provider>
  )
}

/**
 * Hook to check if we're inside an i18n context
 * Safe to use anywhere - returns false when outside any i18n provider
 */
export function useI18nAvailable(): boolean {
  const context = useContext(I18nContext)
  return context.isI18nAvailable
}
